import PropTypes from 'prop-types';
import { colorLookup } from '@medifind/utils';
import { SVG } from './SVG';
const IconArrowBack = (props) => {
  const { color } = props;
  const colorCode = colorLookup(color) ?? colorLookup('blue');

  return (
    <SVG width="25" height="16" viewBox="0 0 33 21" fill={colorCode} xmlns="http://www.w3.org/2000/svg">
      <path
        d="M1.42222 11.4229L10.6473 20.0715C11.2101 20.5992 12.123 20.5992 12.6858 20.0715C13.2488 19.5437 13.2488 18.6882 12.6858 18.1604L5.9214 11.8187L30.5586 11.8187C31.3546 11.8187 32 11.2136 32 10.4673C32 9.72114 31.3546 9.11595 30.5586 9.11595L5.9214 9.11595L12.6856 2.77421C13.2485 2.24643 13.2485 1.39086 12.6856 0.863071C12.4042 0.599394 12.0352 0.467287 11.6663 0.467287C11.2974 0.467287 10.9285 0.599394 10.6471 0.863071L1.42222 9.51173C0.85926 10.0395 0.85926 10.8951 1.42222 11.4229Z"
        fill={colorCode}
        stroke={colorCode}
        strokeWidth="0.5"
      />
    </SVG>
  );
};
IconArrowBack.propTypes = {
  color: PropTypes.string,
};

export { IconArrowBack as default, IconArrowBack };
